import axios from '@_system/axios/axios.js'
export default {
	path: '/relation',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listshop(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listshop', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listwarehouse(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listwarehouse', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	jindieextra(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/jindieextra', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listcustomer(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listcustomer', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listdistributorsupplier(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listdistributorsupplier', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	import(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	export (data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}